import { computed, inject, Injectable } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { AdminDto } from "@malirang/api-client";
import { ADMIN_ACCESS_TOKEN_KEY } from "@malirang/common";
import { BaseStore, LocalStorageService } from "@malirang/front-share";
import { map } from "rxjs";

type State = {
    admin: AdminDto | null;
};

@Injectable({ providedIn: "root" })
export class AdminStore extends BaseStore<State> {
    private readonly router = inject(Router);
    private readonly localStorageService = inject(LocalStorageService);

    admin$ = this.state$.pipe(map((state) => state.admin));
    admin = toSignal(this.admin$);

    isAuth = computed(() => !!this.admin());
    isSuperAdmin = computed(() =>
        this.admin() ? this.admin()!.role === "SUPER_ADMIN" : false,
    );

    constructor() {
        super({
            admin: null,
        });
    }

    setAdmin(admin: AdminDto) {
        this.updateState({
            admin,
        });
    }

    async logout() {
        this.updateState({
            admin: null,
        });

        await this.localStorageService.remove(ADMIN_ACCESS_TOKEN_KEY);
        this.router.navigate(["/login"]);
    }
}
